import _get from "lodash/get";
import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { GaIcon } from '~icon';
import modalTheme from '../../../styles/modalTheme';

var ModalCloseIcon = function ModalCloseIcon(_ref) {
  var color = _ref.color;
  var theme = useContext(ThemeContext);

  var sizeValue = _get(theme, 'modal.closeIcon.size', modalTheme.modal.closeIcon.size);

  return /*#__PURE__*/React.createElement(GaIcon, {
    icon: "x",
    color: color,
    size: sizeValue
  });
};

export default ModalCloseIcon;